import cx from 'classnames';
import { Icon } from '../Icons';
import { useAppProps } from '../../contexts';

type LegacyArrowsProps = {
    arrowDisplay: string;
    advanceIcon: string;
    cursor: number;
    onRetract: () => void;
    onAdvance: () => void;
};

export const LegacyArrows = ({ arrowDisplay, advanceIcon, cursor, onRetract, onAdvance }: LegacyArrowsProps) => {
    const { dictionary } = useAppProps();
    return (
        <div className={cx('sl-arrow-container', { 'display-row': arrowDisplay === 'row' })}>
            <button
                type="button"
                className={cx('sl-arrow', {
                    disabled: !cursor,
                    'display-row': arrowDisplay === 'row'
                })}
                data-testid="competition-filter-arrow-left"
                aria-label={dictionary.arrowLeft}
                disabled={!cursor}
                onClick={onRetract}
            >
                <Icon name="arrow-left" alt={dictionary.arrowLeft} data-test-id={'arrow-left'} />
            </button>
            <button
                type="button"
                className={cx('sl-arrow', { 'display-row': arrowDisplay === 'row' })}
                data-testid="competition-filter-arrow-right"
                aria-label={advanceIcon === 'refresh' ? dictionary.refresh : dictionary.arrowRight}
                onClick={onAdvance}
            >
                <Icon
                    name={advanceIcon}
                    alt={advanceIcon === 'refresh' ? dictionary.refresh : dictionary.arrowRight}
                    data-test-id={advanceIcon}
                />
            </button>
        </div>
    );
};
